import React from 'react';
import { Loader, Table } from 'semantic-ui-react';
import CompactTableRow from '@/components/table/CompactTableRow';
import DatasetSettingsTable from './DatasetSettingsTable';

const DatasetSettingsTableLoader = () => (
  <DatasetSettingsTable className="aridhia-dataset-settings-table-loader">
    <Table.Body>
      <CompactTableRow>
        <Loader active inline size="small" />
      </CompactTableRow>
    </Table.Body>
  </DatasetSettingsTable>
);

export default DatasetSettingsTableLoader;
